module.exports = __webpack_public_path__ + "public/images/yellowBlobAccent.584e1c31216f42a17c6074390b237a34.svg";